module.exports = __webpack_public_path__ + "49f3bdf5e20830046bc3bbe05cf8f37d.png";